import React from 'react';


class AppExtLogo extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      minOffset: 25,
      paddingOffset: 0,
    }

    // Bind event listeners
    this.adjustHeight = ::this.adjustHeight;
  }

  componentWillMount() {
    window.addEventListener('resize', this.adjustHeight, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.adjustHeight, false);
  }

  componentDidMount() {
    setTimeout(() => {
      this.adjustHeight();
    }, 50);
  }

  adjustHeight() {
    if(this.externalBody) {
      let offset = (window.innerHeight - (this.externalBody.offsetHeight - this.state.paddingOffset)) / 2;
      this.setState({ paddingOffset: offset > this.state.minOffset ? offset : this.state.minOffset });
    }
  }

  render() {
    return <div className='AppExtLogo'>
      <div 
        id='externalChildWrapper'
        ref={(div) => { this.externalBody = div; }}
        style={{ paddingTop: this.state.paddingOffset + 'px' }}>
        {this.props.children}
      </div>
    </div>;
  }
}

export default AppExtLogo;


// WEBPACK FOOTER //
// ./src/components/views/common/AppExtLogo.jsx